/* eslint-disable */
export default (function () { });
